import createRoutine from '@/utils/createRoutine'

export const accountCreatedRoutine = createRoutine('accountCreatedRoutine')

export const accountCreatedGetters = {
  ACCOUNT_CREATED: 'ACCOUNT_CREATED'
}

export const ACCOUNT_CREATED_CLEANUP = 'ACCOUNT_CREATED_CLEANUP'
